module.exports = "<div class=\"weui_cell weui_cell_switch\">\n  <cell-body>{{{label}}}</cell-body>\n  <cell-footer>\n    <input type=\"checkbox\" :id=\"id\" :name=\"name\" class=\"weui_switch\" v-model=\"on\">\n  </cell-footer>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/switch-cell.vue
 ** module id = 82
 ** module chunks = 0
 **/